/**
 * Miniatura do YouTube sem chamar API nenhuma: o proprio endereco da imagem
 * e montado a partir do id do video. Menos uma dependencia externa para cair.
 */
export function idDoYouTube(link: string | null | undefined): string | null {
  if (!link) return null;
  try {
    const u = new URL(link);
    const host = u.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') return u.pathname.slice(1).split('/')[0] || null;
    if (host.endsWith('youtube.com') || host.endsWith('youtube-nocookie.com')) {
      const v = u.searchParams.get('v');
      if (v) return v;
      const partes = u.pathname.split('/').filter(Boolean);
      // /embed/<id>, /shorts/<id>, /live/<id>
      if (['embed', 'shorts', 'live', 'v'].includes(partes[0] ?? '')) return partes[1] ?? null;
    }
    return null;
  } catch {
    return null;
  }
}

export function capaDoYouTube(link: string | null | undefined): string | null {
  const id = idDoYouTube(link);
  return id ? `https://i.ytimg.com/vi/${id}/mqdefault.jpg` : null;
}

export function assistirNoYouTube(link: string | null | undefined): string | null {
  const id = idDoYouTube(link);
  return id ? `https://www.youtube.com/watch?v=${id}` : (link ?? null);
}

export function incorporarYouTube(link: string | null | undefined): string | null {
  const id = idDoYouTube(link);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
